import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
Vue.use(Router);
const router = new Router({
    // mode: 'history',
    mode: 'hash',
    linkActiveClass: 'is-active',
    linkExactActiveClass: 'is-current',
    routes,
});
// FOR ACTIVITY INDICATOR
// let pageLoader = null;
// let pageLoaderTimeout = null;
//
// const later = () => {
//     if (!pageLoader) {
//         pageLoader = Toast.loading();
//     }
//     pageLoaderTimeout = null;
// };
//
// const showPageLoader = () => {
//     clearTimeout(pageLoaderTimeout);
//     pageLoaderTimeout = setTimeout(later, 200);
// };
//
// const hidePageLoader = () => {
//     clearTimeout(pageLoaderTimeout);
//     pageLoaderTimeout = null;
//     if (pageLoader) {
//         pageLoader.hide();
//         pageLoader = null;
//     }
// };
//
// router.beforeEach((to, from, next) => {
//     showPageLoader();
//     next();
// });
//
// router.beforeResolve((to, from, next) => {
//     hidePageLoader();
//     next();
// });
export default router;
//# sourceMappingURL=router.js.map
